import { render } from "./CardsSection.vue?vue&type=template&id=2bb553a2"
import script from "./CardsSection.vue?vue&type=script&lang=js"
export * from "./CardsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__